var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheatLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 121,
    viewBox: "0 0 150 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 1,
    width: 4,
    height: 120,
    fill: "#0095FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 34,
    transform: "matrix(-1 0 0 1 32 11)",
    fill: "#0095FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 43,
    transform: "matrix(-1 0 0 1 42 18)",
    fill: "#0095FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 24.1784,
    transform: "matrix(-0.656735 -0.754121 -0.754121 0.656735 40.8605 50.5859)",
    fill: "#0095FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.32394,
    height: 26.4939,
    transform: "matrix(-0.697929 -0.716167 -0.716167 0.697929 42 61)",
    fill: "#0095FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.05804,
    height: 24.8228,
    transform: "matrix(-0.670085 -0.742284 -0.742284 0.670085 41.1448 38.0122)",
    fill: "#0095FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 4,
    height: 34,
    fill: "#0095FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 4,
    height: 43,
    fill: "#0095FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1.13953,
    y: 50.5859,
    width: 4,
    height: 24.1784,
    transform: "rotate(-48.9486 1.13953 50.5859)",
    fill: "#0095FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 61,
    width: 4.32394,
    height: 26.4939,
    transform: "rotate(-45.7389 0 61)",
    fill: "#0095FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.855225,
    y: 38.0122,
    width: 4.05804,
    height: 24.8228,
    transform: "rotate(-47.9264 0.855225 38.0122)",
    fill: "#0095FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 1,
    width: 4,
    height: 120,
    fill: "#0095FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 34,
    transform: "matrix(-1 0 0 1 140 11)",
    fill: "#0095FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 43,
    transform: "matrix(-1 0 0 1 150 18)",
    fill: "#0095FF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 24.1784,
    transform: "matrix(-0.656735 -0.754121 -0.754121 0.656735 148.86 50.5859)",
    fill: "#0095FF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 4.32394,
    height: 26.4939,
    transform: "matrix(-0.697929 -0.716167 -0.716167 0.697929 150 61)",
    fill: "#0095FF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 4.05804,
    height: 24.8228,
    transform: "matrix(-0.670085 -0.742284 -0.742284 0.670085 149.145 38.0122)",
    fill: "#0095FF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 11,
    width: 4,
    height: 34,
    fill: "#0095FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 18,
    width: 4,
    height: 43,
    fill: "#0095FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 109.14,
    y: 50.5859,
    width: 4,
    height: 24.1784,
    transform: "rotate(-48.9486 109.14 50.5859)",
    fill: "#0095FF"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 61,
    width: 4.32394,
    height: 26.4939,
    transform: "rotate(-45.7389 108 61)",
    fill: "#0095FF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 108.855,
    y: 38.0122,
    width: 4.05804,
    height: 24.8228,
    transform: "rotate(-47.9264 108.855 38.0122)",
    fill: "#0095FF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    width: 4,
    height: 120,
    fill: "#0095FF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 34,
    transform: "matrix(-1 0 0 1 86 10)",
    fill: "#0095FF"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 43,
    transform: "matrix(-1 0 0 1 96 17)",
    fill: "#0095FF"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 24.1784,
    transform: "matrix(-0.656735 -0.754121 -0.754121 0.656735 94.8605 49.5859)",
    fill: "#0095FF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 4.32394,
    height: 26.4939,
    transform: "matrix(-0.697929 -0.716167 -0.716167 0.697929 96 60)",
    fill: "#0095FF"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 4.05804,
    height: 24.8228,
    transform: "matrix(-0.670085 -0.742284 -0.742284 0.670085 95.1448 37.0122)",
    fill: "#0095FF"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 10,
    width: 4,
    height: 34,
    fill: "#0095FF"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 17,
    width: 4,
    height: 43,
    fill: "#0095FF"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1395,
    y: 49.5859,
    width: 4,
    height: 24.1784,
    transform: "rotate(-48.9486 55.1395 49.5859)",
    fill: "#0095FF"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 60,
    width: 4.32394,
    height: 26.4939,
    transform: "rotate(-45.7389 54 60)",
    fill: "#0095FF"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 54.8552,
    y: 37.0122,
    width: 4.05804,
    height: 24.8228,
    transform: "rotate(-47.9264 54.8552 37.0122)",
    fill: "#0095FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheatLogo);
export default __webpack_public_path__ + "static/media/WHEAT_LOGO.b46b7c3ffacc5260c811bc1a4d7c6f66.svg";
export { ForwardRef as ReactComponent };